import React from 'react';
import { List, ArrowRight } from 'lucide-react';

export default function TableOfContents({ goToSlide }) {
  const sections = [
    { title: "Pre-University Projects", slideIndex: 1, icon: "🎓" },
    { title: "University Projects", slideIndex: 5, icon: "🏛️" },
    { title: "Co-op Experience", slideIndex: 9, icon: "💼" }
  ];

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="max-w-5xl w-full text-center">
        <h1 className="text-6xl font-bold text-white mb-12">Table of Contents</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {sections.map((section, idx) => (
            <button
              key={idx}
              onClick={() => goToSlide(section.slideIndex)}
              className="bg-white rounded-xl p-8 hover:shadow-2xl transform hover:scale-105 transition-all"
            >
              <div className="text-5xl mb-4">{section.icon}</div>
              <h3 className="text-xl font-bold text-gray-800">{section.title}</h3>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}